import { Button } from '@selina-finance/ui';

type BookCallButtonColor = 'primary-flat' | 'tertiary-flat' | 'secondary';

interface BookCallButtonProps {
    color: BookCallButtonColor;
    className?: string;
    onClick: () => void;
}

export const BookCallButton = ({
    color,
    className,
    onClick,
}: BookCallButtonProps) => (
    <div className={className}>
        <Button
            size='large'
            color={color}
            className='font-bold w-full'
            onClick={onClick}
        >
            Book a call
        </Button>
    </div>
);
